import React, { FC } from 'react';
import classNames from 'classnames';

import { useIsMobile } from '../../../hooks';

import styles from './SkeletonNewsCard.module.scss';

type Props = {
  isExtended?: boolean;
};

const SkeletonNewsCard: FC<Props> = ({ isExtended }: Props): JSX.Element => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.card}>
      <div className={styles.wrapperImage}>
        <div className={classNames(styles.image, { [styles.imgExtended]: isExtended && !isMobile })} />
      </div>
      <div className={styles.dataWrapper}>
        <div className={styles.source} />
        <div className={styles.title} />
        <div className={styles.title} />
      </div>
    </div>
  );
};

export default SkeletonNewsCard;
